"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var en_json_1 = __importDefault(require("./i18n/en.json"));
var fr_json_1 = __importDefault(require("./i18n/fr.json"));
var Footer_1 = require("./Footer");
exports.Footer = Footer_1["default"];
exports.resources = {
    en: en_json_1["default"],
    fr: fr_json_1["default"]
};
